import { SvgIcon, SvgIconProps } from '@mui/material';
import { forwardRef } from 'react';
import Icon from './FlexLoanIcon.svg';

const FlexLoanIcon = forwardRef<SVGSVGElement, SvgIconProps>(
  function FlexLoanIcon(props, ref) {
    return (
      <SvgIcon ref={ref} viewBox="0 0 55 55" {...props}>
        <Icon />
      </SvgIcon>
    );
  }
);

export default FlexLoanIcon;
